import { render, staticRenderFns } from "./DrawerList.vue?vue&type=template&id=54f9ae3e&"
import script from "./DrawerList.vue?vue&type=script&lang=ts&"
export * from "./DrawerList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports